var _defs, _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHerdPlanLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 434 434",
    width: 434,
    height: 434,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 58.3,
    y1: 209.8,
    x2: 355.5,
    y2: 209.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#025376"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#g1)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m355.5 209.8v98.5c0 21.2-17.2 38.4-38.4 38.4-21.2 0-38.4-17.2-38.4-38.4v-60.5h-45v60.5c0 21.2-17.3 38.4-38.5 38.4-21.1 0-38.4-17.2-38.4-38.4v-112.5h-60.1c-7.5 0-13.6 6.1-13.6 13.6 0 7.5 6.1 13.6 13.6 13.6h21.3c6.8 0 12.4 5.6 12.4 12.4 0 6.9-5.6 12.4-12.4 12.4h-21.3c-21.2 0-38.4-17.2-38.4-38.4 0-21.2 17.2-38.5 38.4-38.5h60.1v-59.6c0-21.2 17.3-38.5 38.5-38.5 21.1 0 38.4 17.3 38.4 38.5v20.9c-0.1 6.8-5.6 12.2-12.4 12.2-6.9 0-12.4-5.5-12.4-12.4v-19.3q-0.1-0.6-0.1-1.2 0-0.2 0.1-0.5c-0.2-7.4-6.2-13.3-13.7-13.3-7.5 0-13.6 6.1-13.6 13.6v56 3.7h77.6 19.5v-59.7c0-21.2 17.2-38.5 38.4-38.5 21.2 0 38.4 17.3 38.4 38.5zm-24.8 98.5v-197c0-7.5-6.1-13.6-13.6-13.6-7.4 0-13.5 5.9-13.6 13.3q0 0.3 0 0.6 0 0.5 0 1.1v70.7c0 6.8-5.6 12.4-12.4 12.4h-31.9-77.6v112.5c0 7.5 6.1 13.6 13.6 13.6 7.4 0 13.5-5.9 13.6-13.3q0-0.3 0-0.6 0-0.5 0.1-1.1v-71.5c0-6.8 5.5-12.4 12.4-12.4h69.8c6.8 0 12.4 5.6 12.4 12.4v71.5q0 0.6 0 1.1 0 0.3 0 0.6c0.1 7.4 6.2 13.3 13.6 13.3 7.5 0 13.6-6.1 13.6-13.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHerdPlanLogoIcon);
export default __webpack_public_path__ + "static/media/HerdPlan_Logo_Icon.9b4909de32a65c6c1ddf7b3ef466ced2.svg";
export { ForwardRef as ReactComponent };